import React, { useEffect, useState } from "react";
import api, { formatApiError } from "../../lib/api";
import { Button } from "../ui/button";
import { Rocket, Users, Store, TrendingUp, Euro, ListChecks } from "lucide-react";
import { toast } from "sonner";
import GrowthAdvancedCeo from "./GrowthAdvancedCeo";

const STATE_LABEL = { nuova: "Nuova", da_verificare: "Da verificare", contattata: "Contattata", interessata: "Interessata", onboarding: "Onboarding", attiva: "Attiva", rifiutata: "Rifiutata", da_ricontattare: "Da ricontattare" };

export default function GrowthCeoPanel() {
  const [ov, setOv] = useState(null);
  const [wl, setWl] = useState(null);

  const load = () => {
    api.get("/ceo/growth/overview").then(({ data }) => setOv(data)).catch(() => {});
    api.get("/ceo/growth/wishlist").then(({ data }) => setWl(data)).catch(() => {});
  };
  useEffect(() => { load(); }, []);

  const eur = (v) => "€" + Number(v || 0).toLocaleString("it-IT", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  const setStatus = async (id, status) => {
    try { await api.patch(`/ceo/growth/wishlist/${id}`, { status }); load(); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };

  const o = ov || {};
  const roiPositive = (o.referral_gmv || 0) > 0;
  return (
    <div className="space-y-5" data-testid="growth-ceo-panel">
      <div>
        <h2 className="font-display font-bold text-xl flex items-center gap-2"><Rocket className="h-5 w-5 text-[#FFD700]" /> Growth Engine</h2>
        <p className="text-sm text-zinc-500">Crescita organica: referral clienti e attività, Activity Wishlist (CRM), ROI del programma.</p>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
        <div className="rounded-2xl bg-[#1C1C1F] border border-white/10 p-4" data-testid="gr-invited"><Users className="h-4 w-4 text-[#00E676] mb-1" /><div className="text-2xl font-black">{o.invited ?? 0}</div><div className="text-[10px] uppercase tracking-widest text-zinc-500">Invitati · {o.conversion_rate ?? 0}% attivati</div></div>
        <div className="rounded-2xl bg-[#1C1C1F] border border-white/10 p-4" data-testid="gr-biz"><Store className="h-4 w-4 text-[#00E676] mb-1" /><div className="text-2xl font-black">{o.referred_businesses ?? 0}</div><div className="text-[10px] uppercase tracking-widest text-zinc-500">Attività da referral</div></div>
        <div className="rounded-2xl bg-gradient-to-br from-[#00E676]/15 to-transparent border border-[#00E676]/30 p-4" data-testid="gr-gmv"><Euro className="h-4 w-4 text-[#00E676] mb-1" /><div className="text-2xl font-black">{eur(o.referral_gmv)}</div><div className="text-[10px] uppercase tracking-widest text-[#00E676]">GMV da referral</div></div>
        <div className="rounded-2xl bg-[#1C1C1F] border border-white/10 p-4" data-testid="gr-roi"><TrendingUp className="h-4 w-4 text-[#FFD700] mb-1" /><div className="text-2xl font-black">{(o.reward_points_issued ?? 0).toLocaleString("it-IT")}</div><div className="text-[10px] uppercase tracking-widest text-zinc-500">Punti reward erogati {roiPositive ? "· ROI +" : ""}</div></div>
      </div>

      {o.top_scouts?.length > 0 && (
        <div className="rounded-2xl bg-[#1C1C1F] border border-white/10 p-5">
          <div className="text-sm font-semibold mb-3">Top Scout (attività portate)</div>
          <div className="space-y-2">
            {o.top_scouts.map((s, i) => (
              <div key={s.user_id} className="flex items-center justify-between text-sm" data-testid={`gr-scout-${i}`}><span className="text-zinc-400">{i + 1}. {s.name}</span><span className="font-semibold">{s.businesses} attività</span></div>
            ))}
          </div>
        </div>
      )}

      <div className="rounded-2xl bg-[#1C1C1F] border border-white/10 p-5">
        <div className="text-sm font-semibold mb-3 flex items-center gap-2"><ListChecks className="h-4 w-4 text-[#00E676]" /> Activity Wishlist — attività più richieste ({wl?.total ?? 0})</div>
        <div className="space-y-2">
          {(wl?.wishlist || []).map((w) => (
            <div key={w.id} data-testid={`wishlist-${w.id}`} className="flex items-center justify-between gap-3 flex-wrap border-t border-white/5 pt-2">
              <div className="min-w-0">
                <div className="font-semibold">{w.name} <span className="text-zinc-500 text-xs">· {w.comune}{w.category ? ` · ${w.category}` : ""}</span></div>
                <div className="text-xs text-[#FFD700]">{w.requests_count} richieste · {w.proposers_count} utenti interessati</div>
              </div>
              <select data-testid={`wishlist-status-${w.id}`} value={w.status} onChange={(e) => setStatus(w.id, e.target.value)} className="bg-[#0A0A0C] border border-white/10 rounded-md h-8 px-2 text-xs">
                {Object.entries(STATE_LABEL).map(([k, l]) => <option key={k} value={k}>{l}</option>)}
              </select>
            </div>
          ))}
          {wl && (wl.wishlist || []).length === 0 && <div className="text-zinc-500 text-sm py-4 text-center">Nessuna attività richiesta ancora.</div>}
        </div>
      </div>

      <GrowthAdvancedCeo />
    </div>
  );
}
